import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { colors } from '@retailer-platform/shared-components'
import { Link } from 'react-router-dom'
import { useDomainCreateHrefFactory } from 'domains/products/utils/domain/routing'
import { useProductViewRoute } from 'domains/products/components/view/utils/useProductViewRoute.hooks'
import { type DomainRouteName } from 'domains/products/routing/routes'

interface Props {
  productId: string
}

const ProductLink = styled(Link)({
  maxWidth: '100%',
  cursor: 'pointer',
  textDecoration: 'underline',
  color: colors.GRAYSCALE.X70,
})

export const ProductsSearchTableProductNameCell: FunctionComponent<Props> = ({
  productId,
  children,
}) => {
  const { route, query } = useProductViewRoute('productEditDetails', productId)

  if (typeof route === 'string') throw new Error('Route given is a string. Expecting object.')

  const productLink = useDomainCreateHrefFactory(route.name as DomainRouteName, route.params, query)

  return <ProductLink to={productLink}>{children}</ProductLink>
}
